import { Input } from 'antd';
import classNames from 'classnames';
import { memo, useMemo } from 'react';
import { CustomInputProps } from '../../interfaces';
import '../../styles.scss';
import { createNewWidthHeightStyle } from '../../utils';
import './styles.scss';

const CustomNumberInput: React.FC<CustomInputProps> = props => {
  const {
    min,
    max,
    width,
    height,
    onChange,
    className,
    style = {},
    noMarginPrefix = false,
    ...rest
  } = props;

  const newStyle = useMemo(() => {
    return { ...style, ...createNewWidthHeightStyle({ width, height }) };
  }, [width, height, style]);

  const newClassName = classNames(className, 'custom-number-input', {
    noMarginPrefix,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const reg = /^-?\d*(\.\d*)?$/;
    if (
      (!isNaN(Number(value)) && reg.test(value)) ||
      value === '' ||
      value === '-'
    ) {
      if (onChange) {
        onChange(className?.includes('controlledInput') ? (value as any) : e);
      }
    }
  };

  return (
    <Input
      {...rest}
      onChange={handleChange}
      style={newStyle}
      className={newClassName}
    />
  );
};

export default memo(CustomNumberInput);
